const PREFIX = 'USER/';
export const USER_LIST = `${PREFIX}LIST`;
export const USER_GET = `${PREFIX}GET`;
export const USER_UPDATE = `${PREFIX}UPDATE`;
export const USER_UPDATE_STATUS = `${PREFIX}UPDATE_STATUS`;
export const USER_CREATE = `${PREFIX}CREATE`;
export const USER_DELETE = `${PREFIX}DELETE`;
export const RESET_SELECTED_USER = `${PREFIX}RESET_SELECTED_USER`;
export const SET_SELECTED_USER = `${PREFIX}SET_SELECTED_USER`;
